import { TEMPLATES } from "../../enums/enums";
import type { ProjectTemplate } from "../../types";
import { routes } from "../lib/routes";
import { INFRA_STARTERS, STARTERS } from "./useAddTemplates";

const LOGOS = "https://microtica.s3.eu-central-1.amazonaws.com/assets/templates/logos";
// The classic avatar's matches, first one wins; names are matched in lower case
const LOGO_BY_NAME: [string, string][] = [
    ["n8n", "n8n.png"], ["strapi", "strapi.png"], ["nextjs", "nextjs.png"], ["nuxtjs", "nuxtjs.svg"],
    ["rocketchat", "rocketchat.png"], ["react", "reactjs.png"], ["angular", "angularjs.png"], ["vuejs", "vuejs.png"],
    ["fargate", "fargate.png"], ["spa", "cloudfront.png"], ["webiny", "webiny.png"], ["appwrite", "appwrite.svg"],
    ["nginx", "nginx.png"], ["svelte", "svelte.png"], ["gatsby", "gatsby.png"], ["nodejs", "nodejs.png"],
    ["gin", "gin.png"], ["nest", "nestjs.svg"], ["iris", "iris.png"], ["django", "django.png"], ["python", "python.png"],
    ["medusa", "medusa.png"], ["lambda", "lambda.png"],
];

/** A template's logo, when its name says what it runs */
export function templateLogo(name: string): string | undefined {
    const n = name.toLowerCase();
    const hit = LOGO_BY_NAME.find(([match]) => n.includes(match));
    return hit && `${LOGOS}/${hit[1]}`;
}

export type TemplateKind = "service" | "infra";

/** Whether a template starts a service (an app on Kubernetes) or infrastructure (a component) */
export function templateKind(t: ProjectTemplate): TemplateKind {
    const builtIn = TEMPLATES.find(b => b.key === t.id);
    if (builtIn) return builtIn.type === "app" ? "service" : "infra";
    return t.link?.includes("/templates/apps/") ? "service" : "infra";
}

/** Microtica's templates, or the team's own: components and services only this project's projects can use */
export const isOwn = (t: ProjectTemplate) => t.type === "component" && !t.public;

/** The add flow for one of Microtica's free starters, by its key; undefined for the ones that keep the classic flow */
export function starterAddLink(projectId: string, key: string, env?: string): string | undefined {
    if (STARTERS.some(s => s.key === key)) return routes.add(projectId, { env, kind: "service", starter: key });
    if (INFRA_STARTERS.some(s => s.key === key)) return routes.add(projectId, { env, kind: "infra", starter: key });
    return undefined;
}

/**
 * Where a card leads in the new UI: the add flow, with the template picked and the environment
 * still to choose. Premium service starters keep the classic flow, which handles their plan upgrade.
 */
export function templateLink(projectId: string, t: ProjectTemplate): string {
    const starter = t.type === "template" ? starterAddLink(projectId, t.id) : undefined;
    if (starter) return starter;
    if (t.link?.includes("/templates/components/")) return routes.add(projectId, { kind: "infra", template: t.id });
    if (t.link?.includes("/templates/apps/")) return routes.add(projectId, { kind: "service", service: t.id });
    return t.link;
}
